import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseService } from '../loja/base.service';

@Injectable()
export class EditalTypeService extends BaseService {
  constructor(protected http: Http) {
    super(http, 'api/v2/admin', 'asap-user/permission/module');
  }
}


// WEBPACK FOOTER //
// ./src/app/services/edital/edital-type.service.ts